var map = {
	"./de.png": 1034,
	"./en.png": 1035,
	"./es.png": 1036,
	"./fr.png": 1037,
	"./ja.png": 1038,
	"./mk.png": 1039,
	"./pt.png": 1040,
	"./tr.png": 1041,
	"./zh.png": 1042
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1033;


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/language-switcher/flags ^\.\/.*\.png$
// module id = 1033
// module chunks = 0